/* eslint-disable react/destructuring-assignment, react/jsx-props-no-spreading */
import React from 'react';
import PropTypes from 'prop-types';

import {
    commonDefaultProps,
    commonPropTypes,
    concatClassNames,
    ypUtilsToClassNames,
    filterProps,
} from '../Abstrap/Abstrap';

const propTypes = {
    ...commonPropTypes,
    type: PropTypes.oneOf(['info', 'success', 'warning', 'error']),
    inner: PropTypes.bool,
    large: PropTypes.bool,
};

const defaultProps = {
    ...commonDefaultProps,
    type: 'info',
    inner: false,
    large: false,
};

const MessageBox = (props) => {
    const classNames = [
        'c-msg-box',
        props.inner ? 'c-msg-box--inner' : '',
        props.large ? 'c-msg-box--large' : '',
        props.type ? `c-msg-box--${props.type}` : '',
        props.className,
        ...ypUtilsToClassNames(props.ypUtils),
    ];
    return (
        <props.componentClass
            className={concatClassNames(classNames)}
            {...filterProps(propTypes, props)}
        >
            {props.children}
        </props.componentClass>
    );
};

MessageBox.propTypes = propTypes;

MessageBox.defaultProps = defaultProps;

export default MessageBox;
